import { setShowListPane, setShowReadingPane } from 'owa-mail-layout';
import { action } from 'satcheljs/lib/legacy';
import { getActiveContentTab, TabType } from 'owa-tab-store';
import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';

/**
 * Decides whether to hide LP after a reply or reply all or forward message action in SLV
 */
export default action('onReplyOrReplyAllOrForwardMessage')(
    function onReplyOrReplyAllOrForwardMessage() {
        const activeTab = getActiveContentTab();
        if (isReadingPanePositionOff() && (!activeTab || activeTab.type == TabType.Primary)) {
            setShowReadingPane(true /* showReadingPane */);
            setShowListPane(false /* showListPane */);
        }
    }
);
